export default {
    apiUrl: 'http://localhost:8081/api',
    env: 'dev',

    //  Auth Stuff
    authDomain: 'dsha-aw-stage.us.auth0.com',
    authAudience: 'https://dsha-aw-stage.tangatek.net/',
    authClientId: 'udAElRXSSl1QpI1yNDeY3IFVxGQ250jM',
}
